var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDropZm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 98,
    viewBox: "0 0 74 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3188 24.5051C46.9832 24.632 44.5921 26.7693 42.8515 30.5583C42.8515 30.5583 29.7105 51.1488 26.7069 62.911C20.176 76.593 28.7267 92.6297 42.5008 96.1839C39.8041 97.0681 37.0018 97.59 34.1675 97.7357C10.1799 99.3335 -7.27373 73.4466 3.0128 51.8771C7.07155 35.9943 24.8219 8.18597 24.8219 8.18597C29.2646 -1.49285 36.8379 -3.18902 41.1299 6.34541L49.3188 24.5051Z",
    fill: "#A2D45E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1251_6718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1597 80.7559C69.6104 83.5568 67.373 85.917 64.6585 87.6139C61.9439 89.3108 58.8418 90.2884 55.6446 90.4546C54.863 90.5068 54.0789 90.5098 53.297 90.4633C40.5448 89.669 31.8225 75.5709 37.4773 63.7142C39.8444 54.4499 50.1926 38.2336 50.1926 38.2336C50.8484 36.61 51.9369 35.1971 53.3397 34.1485C53.8059 33.806 54.35 33.5847 54.923 33.5045C55.4961 33.4242 56.0801 33.4876 56.6225 33.6888C58.0593 34.4038 59.1617 35.6492 59.6968 37.1619L69.8898 59.7445C71.5138 63.1808 73.4434 66.4987 73.5161 70.6071C73.7057 74.1453 72.8868 77.6645 71.1549 80.7559H71.1597Z",
    fill: "#CB007B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1251_6718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.8267,
    height: 57.0257,
    fill: "white",
    transform: "translate(35.7153 33.4707)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDropZm);
export default __webpack_public_path__ + "static/media/logo_drop_ZM.08da968b50561c413427c53102066fce.svg";
export { ForwardRef as ReactComponent };